module.exports = __webpack_public_path__ + "static/media/english-flag-large.5eaefc9e.png";